// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6463":"b6ece8b7","6849":"44210f26","8378":"b6ece8b7","8901":"44210f26"}[chunkId] + ".chunk.css";
};